import { getFirestore, collection, onSnapshot, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { firebaseApp } from "../../system/firebase";

const SubrouteEvents = () => {
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [subscribers, setSubscribers] = useState([]);
    const db = getFirestore(firebaseApp);

    useEffect(() => {
        const q = query(
            collection(db, 'ALL_EVENTS')
            // where('eventType', '==', 'Conference')
        );
        const unsub = onSnapshot(q, (snapshot) => {
            const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setEvents(list);
            if (list.length > 0 && !selectedEvent) {
                setSelectedEvent(list[0]);
            }
        });
        return () => unsub();
    }, []);

    useEffect(() => {
        if (!selectedEvent) return;
        const q = query(
            collection(db, 'ALL_SUBSCRIBERS'),
            where('eventId', '==', selectedEvent.id)
        );
        const unsub = onSnapshot(q, (snapshot) => {
            const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setSubscribers(list);
        });
        return () => unsub();
    }, [selectedEvent]);

    const onCopyEmails = () => {
        const emails = subscribers.map(s => s.email).join(",");
        navigator.clipboard.writeText(emails);
        alert(subscribers.length + " Emails copied");
    };

    const changeDate = (date) => {
        if (!date) return '—';
        const dateObj = new Date(date);
        return `${dateObj.getDate()}/${dateObj.getMonth() + 1}/${dateObj.getFullYear()}`;
    };

    return (
        <div className='main-content'>
            <div className='main-header'>
                <h1 className='noPadding main-heading'><span className='title-thin'>Admin</span> Events </h1>
                <div className='main-header-right'>
                    <div>ABSK ADMIN</div>
                    <div className='profile-small'></div>
                </div>
            </div>

            <div className='events-layout'>
                <div className='events-sidebar'>
                    <h3>Events</h3>
                    {
                        events.length === 0 ? (
                            <p>No events yet</p>
                        ) : (
                            <div className='events-list'>
                                {events.map((event) => (
                                    <div
                                        key={event.id}
                                        className={`event-item ${selectedEvent?.id === event.id ? 'active' : ''}`}
                                        onClick={() => setSelectedEvent(event)}
                                    >
                                        <div className='event-name'>{event.name}</div>
                                        {
                                            event.eventType === 'Conference' && (
                                                <div className='event-date'>{changeDate(event.startDate)} – {changeDate(event.endDate)}</div>
                                            )
                                        }
                                        {
                                            event.eventType === 'Webinar' && (
                                                <div className='event-date'>{changeDate(event.date)}</div>
                                            )
                                        }
                                    </div>
                                ))}
                            </div>
                        )
                    }
                </div>

                <div className='subscribers-section'>
                    <div className='subscribers-header'>
                        <div className='sub-title-block'>
                            <h3>Subscribers for {selectedEvent?.name}</h3>
                            <div className='sub-count'>{subscribers.length} total</div>
                        </div>
                        <div className="copy-emails" onClick={onCopyEmails}>COPY EMAILS</div>
                    </div>

                    <div className='subscribers-list'>
                        {subscribers.length === 0 ? (
                            <div className='no-data'>No subscribers yet</div>
                        ) : (
                            <table className='admin-table'>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Type</th>
                                        <th>Payment Ref</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {subscribers.map((sub, index) => (
                                        <tr key={index}>
                                            <td>{sub.name}</td>
                                            <td>{sub.email}</td>
                                            <td>{sub.presenceType}</td>
                                            <td>{sub.paymentReference || 'N/A'}</td>
                                            <td>
                                                <span className={`status-badge ${sub.status || 'pending'}`}>
                                                    {sub.status || 'pending'}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubrouteEvents;